<template>
  <div>
    Product
  </div>
</template>

<script>

  export default {
    name: 'Product'
  };

</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product/index.vue